import React from 'react';

const Pagination = (props) => {
	return (
		<div className="columns pagination is-centered">
			<button className="button pagination-previous" onClick={props.onPrevPage} disabled={!props.hasBefore}>Pagina precedente</button>
			<button className="button pagination-next" onClick={props.onNextPage} disabled={!props.hasNext}>Pagina successiva</button>
		</div>
	)
};

export default Pagination


// WEBPACK FOOTER //
// ./src/components/pagination.jsx